interface DashnoardHeaderProps {
  title?: string | React.ReactNode;
  children?: React.ReactNode;
}

export const DashboardHeader = ({ title, children }: DashnoardHeaderProps) => {
  return (
    <div className="-mt-6 py-7.5 bg-white border-b border-b-gray-F1F0F3">
      <div className="container-fixed flex flex-wrap items-center justify-between gap-4">
        <div className="flex flex-1 items-center">
          <h1 className="text-2xl font-bold">{title}</h1>
        </div>
        <div className="flex items-center max-sm:w-full">{children}</div>
      </div>
    </div>
  );
};
